import Dictionary from "../../../models/Dictionary";

const FIXED_COLUMNS = ["requestId", "shortCode", "title"] as const;

const CONFIGURABLE_COLUMNS = [
  "priority",
  "directCustomer",
  "customerClassification",
  "pnsPotential",
  "requester",
  "submissionOrApprovalDate",
  "estimatedFinishingDate",
  "deadLine",
  "assigneeName",
  "status",
  "marketSegment",
  "applicationField",
] as const;

const COLUMN_LABELS = [
  "ID",
  "Priority",
  "Short Code",
  "Request Name",
  "Customer",
  "Class",
  "PNS Potential",
  "Requester",
  "Submission",
  "EFD",
  "Deadline",
  "Responsible",
  "Status",
  "Market Segment",
  "Application Field",
] as const;

type TestRequestOverviewFixedColumns = typeof FIXED_COLUMNS[number];
type TestRequestOverviewConfigurableColumns = typeof CONFIGURABLE_COLUMNS[number];
export type TestRequestOverviewColumns = TestRequestOverviewFixedColumns | TestRequestOverviewConfigurableColumns;
export type TestRequestOverviewColumnLabels = typeof COLUMN_LABELS[number];
export type TestRequestSortColumn = TestRequestRaw.Schemas.TestRequestSortColumn;

export const columnsDictionary: Dictionary<TestRequestOverviewColumns, TestRequestOverviewColumnLabels> = {
  requestId: "ID",
  shortCode: "Short Code",
  priority: "Priority",
  title: "Request Name",
  directCustomer: "Customer",
  customerClassification: "Class",
  pnsPotential: "PNS Potential",
  requester: "Requester",
  submissionOrApprovalDate: "Submission",
  estimatedFinishingDate: "EFD",
  deadLine: "Deadline",
  assigneeName: "Responsible",
  status: "Status",
  marketSegment: "Market Segment",
  applicationField: "Application Field",
};

export const sortColumnsDictionary: { [CL in TestRequestOverviewColumnLabels]?: TestRequestSortColumn } = {
  "Application Field": "APPLICATION_FIELD",
  Priority: "PRIORITY",
  Customer: "CUSTOMER",
  Class: "CUSTOMER_CLASSIFICATION",
  "PNS Potential": "PNS_POTENTIAL",
  Requester: "REQUESTER",
  "Short Code": "SUBMISSION_DATE",
  Status: "STATE",
  Submission: "SORTING_DATE",
  "Request Name": "TITLE",
  "Market Segment": "MARKET_SEGMENT",
  EFD: "ESTIMATED_FINISHING_DATE",
  Deadline: "DEADLINE",
  Responsible: "ASSIGNEE",
};

export const fixedColumns = [...FIXED_COLUMNS];
export const fixedColumnLabels = FIXED_COLUMNS.map((fc) => columnsDictionary[fc]);
export const configurableColumns = [...CONFIGURABLE_COLUMNS];
export const configurableColumnLabels = CONFIGURABLE_COLUMNS.map((vc) => columnsDictionary[vc]);
export const defaultSortColumnLabel = columnsDictionary.submissionOrApprovalDate;
export const defaultSortColumn = "SORTING_DATE";

export default TestRequestOverviewColumns;
